<template>
  <div class="drugs_detail">
    <div class="drugs_detail_title">{{ name }}</div>
    <div class="drugs_detail_content">
      <div class="drugs_detail_content_ul">
        <p v-for="(item, index) in dataArr" :key="index">
          {{ item }}
        </p>
      </div>
      <!-- <img :src="url" class="drugs_detail_content_img" alt=""> -->
      <img
        :src="'/static/images/'+id+'.jpg'"
        class="drugs_detail_content_img"
        alt=""
      />
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  data() {
    return {
      dataArr: [],
      id: "",
      name: "",
    };
  },
  created() {
    this.id = this.$route.query.did;
    this.name = this.$route.query.name;
    this.init();
  },
  methods: {
    init() {
      $.ajax({
          url:"/static/json/bencao/" + this.id + ".json",
          type:'GET',
          success:(res)=>{
            this.dataArr = res;
          }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.drugs_detail {
  // background-color: rgb(249, 239, 219);
  .drugs_detail_title {
    margin: 0 auto;
    width: 1200px;
    height: 52px;
    font-family: bold;
    font-size: 24px;
    text-align: center;
    line-height: 52px;
    padding-top: 50px;
    margin-bottom: 20px;
  }
  .drugs_detail_content {
    width: 1200px;
    margin: 0 auto;
    padding: 0px 20px 100px;
    .drugs_detail_content_ul {
      display: inline-block;
      width: 900px;
      p {
        width: 100%;
        padding: 0px 20px;
        box-sizing: border-box;
        line-height: 26px;
      }
    }
    .drugs_detail_content_img {
      display: inline-block;
      width: 300px;
      vertical-align: top;
    }
  }
}
</style>